import React, { useEffect, useState } from "react";
import axios from "axios";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { Box, Typography, Card, CardContent, LinearProgress } from "@mui/material";
import API_ENDPOINTS from "../config/apiConfig";

function Dashboard() {
  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(true);

  const columnDefs = [
    {
      headerName: "Voter ID",
      field: "voterID",
      filter: true,
      width: 200,
      cellStyle: { fontWeight: 500 }
    },
    {
      headerName: "HighLevel ID",
      field: "highlevelId",
      filter: true,
      width: 200,
    },
    {
      headerName: "Status",
      field: "Status",
      filter: true,
      width: 150,
      cellStyle: params => {
        if (params.value === 'Active') return { color: '#2e7d32' };
        if (params.value === 'Inactive') return { color: '#d32f2f' };
        return null;
      }
    },
    {
      headerName: "Last Name",
      field: "lastName",
      filter: true,
      width: 200,
    },
    {
      headerName: "First Name",
      field: "firstName",
      filter: true,
      width: 200,
    },
    {
      headerName: "Suffix",
      field: "Suffix",
      filter: true,
      width: 100,
    },
    {
      headerName: "Date of Birth",
      field: "birthday",
      filter: true,
      width: 200,
      valueFormatter: (params) => {
        const { day, month, year } = params.value;
        return `${day}/${month}/${year}`;
      },
    },
    {
      headerName: "Street Name",
      field: "address1",
      filter: true,
      width: 250,
    },
    {
      headerName: "City",
      field: "City",
      filter: true,
      width: 200,
    },
    {
      headerName: "State",
      field: "State",
      filter: true,
      width: 120,
    },
    {
      headerName: "Zip Code",
      field: "postalCode",
      filter: true,
      width: 150,
    },
    {
      headerName: "Gender",
      field: "gender",
      filter: true,
      width: 150,
    },
    {
      headerName: "Recurring VBM",
      field: "Recurring_VBM",
      filter: true,
      width: 200,
      cellStyle: params => {
        if (params.value === 'TRUE') return { color: '#2e7d32', fontWeight: 500 };
        return null;
      }
    },
  ];

  const defaultColDef = {
    resizable: true,
    minWidth: 100,
    flex: 1,
    filter: true,
    floatingFilter: true,
    cellStyle: { 
      borderRight: '1px solid #e0e0e0',
      padding: '8px'
    },
    headerClass: 'custom-header'
  };

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const response = await axios.get(API_ENDPOINTS.dashboardRecords);
        setRowData(response.data);
      } catch (error) {
        console.error("Error fetching contacts:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchContacts();
  }, []);

  return (
    <Card sx={{ minHeight: '700px', display: 'flex', flexDirection: 'column', overflow: 'auto' }}>
      <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column', p: 3, minHeight: '650px', overflow: 'auto' }}>
        <Typography variant="h5" gutterBottom sx={{ color: '#002855', fontWeight: 'bold', mb: 2 }}>
          Voters Data
        </Typography>
        {loading ? (
          <Box sx={{ width: '100%', mt: 2 }}>
            <LinearProgress />
          </Box>
        ) : (
          <Box 
            className="ag-theme-alpine" 
            sx={{ 
              height: '600px',
              width: '100%',
              overflow: 'auto',
              '& .ag-header': {
                backgroundColor: '#f5f5f5',
                color: '#333',
                fontSize: '14px',
                fontWeight: 'bold',
                height: '48px',
                borderBottom: '2px solid #e0e0e0'
              },
              '& .ag-header-cell': {
                borderRight: '1px solid #e0e0e0'
              },
              '& .ag-row': {
                borderBottom: '1px solid #e0e0e0',
                '&:hover': {
                  backgroundColor: '#f5f5f5'
                }
              },
              '& .ag-row-odd': {
                backgroundColor: '#fafafa'
              },
              '& .ag-paging-panel': {
                borderTop: '1px solid #e0e0e0',
                padding: '8px',
                background: '#fff',
                position: 'sticky',
                bottom: 0,
                zIndex: 2
              }
            }}
          >
            <AgGridReact
              rowData={rowData}
              columnDefs={columnDefs}
              pagination={true}
              paginationPageSize={25}
              animateRows={true}
              defaultColDef={defaultColDef}
              enableCellTextSelection={true}
              rowHeight={48}
              headerHeight={48}
              suppressHorizontalScroll={false}
              enableRangeSelection={true}
              suppressRowClickSelection={true}
              rowSelection="multiple"
            />
          </Box>
        )}
      </CardContent>
    </Card>
  );
}

export default Dashboard;
